export default `
    <h1>
      LEGAL DISTRIBUTION B2B CONTRACT FOR INVESTHINKS
    </h1>
    
    <h3>CONTRACTING PARTIES:</h3>
    
    <p>1. <strong>On the one hand, INVESTHINKS, S.L.,</strong> with Tax ID B06986152, domiciled at Teodoro Canet 28 street, Alcúdia (07400), Balearic Islands, represented by its administrator, [Name of representative]. Hereinafter, <strong>"INVESTHINKS"</strong>.</p>
    <p>2. <strong>On the other hand, the DISTRIBUTOR,</strong> a natural or legal person who completes the registration process as an INVESTHINKS distributor on the platform, accepting the conditions of this contract by activating a checkbox during the registration process. Hereinafter, <strong>"THE DISTRIBUTOR"</strong>.</p>
    
    <h3>CLAUSES</h3>

    <p><strong>FIRST. OBJECT OF THE CONTRACT</strong></p>
    <p>The purpose of this contract is to establish the general conditions of collaboration between INVESTHINKS and THE DISTRIBUTOR for the promotion and distribution of INVESTHINKS' automated trading services among the DISTRIBUTOR's clients, acting as an independent intermediary.</p>

    <p><strong>SECOND. DEFINITIONS OF TERMS</strong></p>
    <ul>
        <li><p><strong>Client:</strong> Any person who has been introduced by THE DISTRIBUTOR and who meets the requirements to open an account at Investhinks, with at least one active operation.</p></li>
        <li><p><strong>Investhinks Account:</strong> Access to the INVESTHINKS platform to manage automated trading operations and view performance.</p></li>
        <li><p><strong>Distributor:</strong> Natural or legal person who acts as an independent intermediary to present clients to INVESTHINKS.</p></li>
        <li><p><strong>Distributor Commissions:</strong> Remuneration that THE DISTRIBUTOR receives based on the introduced clients and their performance.</p></li>
        <li><p><strong>Distribution Program:</strong> Reference system that allows THE DISTRIBUTOR to obtain commissions for each client they register.</p></li>
    </ul>

    <p><strong>THIRD. CONDITIONS OF THE DISTRIBUTION PROGRAM</strong></p>
    <ol>
        <li><p>THE DISTRIBUTOR will obtain commissions for each client they introduce who maintains an active account with a connected investment bot.</p></li>
        <li><p>Commissions will be calculated based on a percentage of the performance generated by each client, according to the tiers defined in Annex I.</p></li>
        <li><p>Commissions will be paid to THE DISTRIBUTOR's electronic wallet, available on their dashboard.</p></li>
        <li><p>THE DISTRIBUTOR will be responsible for promoting INVESTHINKS services ethically, complying with applicable regulations and avoiding deceptive practices.</p></li>
    </ol>

    <p><strong>FOURTH. RIGHTS AND OBLIGATIONS OF INVESTHINKS</strong></p>
    <ol>
        <li><p>INVESTHINKS will provide THE DISTRIBUTOR with access to their dashboard, marketing materials, training, and technical support.</p></li>
        <li><p>INVESTHINKS commits to processing commissions monthly, provided that THE DISTRIBUTOR meets the requirements.</p></li>
        <li><p>INVESTHINKS reserves the right to modify the conditions of the distribution program with 15 days prior notice.</p></li>
        <li><p>INVESTHINKS may terminate the contract immediately in case of serious breach by THE DISTRIBUTOR.</p></li>
    </ol>

    <p><strong>FIFTH. RIGHTS AND OBLIGATIONS OF THE DISTRIBUTOR</strong></p>
    <ol>
        <li><p>THE DISTRIBUTOR has the right to receive commissions generated by clients they introduce.</p></li>
        <li>
            <p>THE DISTRIBUTOR commits to:</p>
            <ul>
                <li><p>Use marketing materials provided by INVESTHINKS.</p></li>
                <li><p>Not use the INVESTHINKS logo without prior authorization.</p></li>
                <li><p>Not register domain names that include the "Investhinks" brand.</p></li>
                <li><p>Not send unsolicited mass emails (spam) or engage in deceptive advertising.</p></li>
            </ul>
        </li>
        <li><p>THE DISTRIBUTOR will be responsible for complying with their tax obligations derived from commission income.</p></li>
    </ol>

    <p><strong>SIXTH. CONDITIONS OF DISTRIBUTOR ACTIVITY</strong></p>
    <ol>
        <li><p>THE DISTRIBUTOR must have a personal account (as a natural or legal person) at Investhinks with, at minimum, one connected and active bot.</p></li>
        <li><p>THE DISTRIBUTOR must maintain continuous activity, incorporating at least one active client every 60 days.</p></li>
        <li><p>In case of inactivity for 120 consecutive days, INVESTHINKS reserves the right to suspend pending commissions.</p></li>
        <li><p>Any fraud detected in THE DISTRIBUTOR's activity will result in immediate termination of the contract.</p></li>
    </ol>

    <p><strong>SEVENTH. DATA PROTECTION AND CONFIDENTIALITY</strong></p>
    <ol>
        <li><p>THE DISTRIBUTOR commits to maintaining the confidentiality of all commercial, technical, and financial information provided by INVESTHINKS.</p></li>
        <li><p>The personal data of introduced clients will be managed exclusively by INVESTHINKS, in accordance with current data protection legislation.</p></li>
        <li><p>THE DISTRIBUTOR may not retain or process client data without authorization.</p></li>
    </ol>

    <p><strong>EIGHTH. MODIFICATION AND TERMINATION</strong></p>
    <ol>
        <li><p>INVESTHINKS reserves the right to modify this contract, notifying changes with a minimum notice of 15 days.</p></li>
        <li><p>Either party may terminate the contract with 15 days' notice, except in case of serious breach.</p></li>
        <li><p>In case of termination, THE DISTRIBUTOR will receive pending commissions, provided they comply with the established conditions.</p></li>
    </ol>

    <p><strong>NINTH. APPLICABLE LAW AND JURISDICTION</strong></p>
    <ol>
        <li><p>This contract will be governed by Spanish legislation.</p></li>
        <li><p>For the resolution of any conflict arising from this contract, the parties expressly submit to the Courts and Tribunals of Palma.</p></li>
    </ol>

    <p><strong>TENTH. ELECTRONIC ACCEPTANCE</strong></p>
    <ol>
        <li><p>THE DISTRIBUTOR accepts this contract electronically by activating the acceptance checkbox during the registration process.</p></li>
        <li><p>This electronic acceptance has the same legal validity as a handwritten signature.</p></li>
    </ol>
    
    <h2>ANNEX I: COMMISSION CONDITIONS</h2>
    
    <ul>
        <li><p>Tier 1: 5% (VAT included) of the monthly performance of accounts from clients introduced by THE DISTRIBUTOR.</p></li>
    </ul>
`;
